<template>
  <div v-if="frameSpec" class="pv-gallery__item-upload--artwork pv-gallery__item-upload">
    <MaskedRenderer v-if="showMaskRenderer" :frameSpec="frameSpec" class="content masked-renderer" />
    <RenderSvgFrame v-else :frameSpec="frameSpec" class="content" />
    <Teleport v-if="galleryZoomCell" :to="galleryZoomCell">
      <div class="pv-gallery__item-upload">
        <div v-if="showMaskRenderer" class="pv-gallery__item-upload__zoom-artwork">
          <MaskedRenderer
            :frameSpec="frameSpec"
            class="content masked-renderer __uploaded-shadow"
          />
        </div>
        <RenderSvgFrame v-else :frameSpec="frameSpec" class="content __uploaded-shadow" />
      </div>
    </Teleport>
  </div>
  <div
    v-else-if="!buildFailed"
    class="pv-gallery__item-upload--artwork-loading is-loading"
  ></div>
</template>

<script>
import {
  onMounted, onUnmounted, watch, Teleport
} from "vue";
import RenderSvgFrame from '@framebridge/toolbox/components/RenderSvg/RenderSvgFrame.vue';
import MaskedRenderer from '@framebridge/toolbox/MaskedRenderer';
import useFrameSpecData from '../composables/frame-spec';

export default {
  name: 'PostArtwork',
  components: {
    RenderSvgFrame,
    MaskedRenderer,
    Teleport,
  },

  props: {
    handle: {
      type: String,
      required: true,
    },
    productId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    variantSpec: {
      type: String,
      required: false,
    },
    variantId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const {
      frameSpec,
      buildFailed,
      checkFrameSpecData,
      getFrameSpecById,
      showMaskRenderer,
    } = useFrameSpecData(
      {
        handle: props.handle,
        type: props.type,
        id: props.productId,
      },
      null,
      props.variantSpec,
      props.variantId
    );
    const galleryModal = document.getElementById(`productGalleryZoomModal${props.variantId}`) || null;
    const galleryZoomCell = galleryModal?.querySelector('.js-post-artwork-zoom') || null;

    const loadFrameSpec = () => {
      checkFrameSpecData();
    };

    const handleUploadEvent = (event) => {
      if (event?.detail?.added) {
        loadFrameSpec();
      }
    };

    const removeParentCell = () => {
      const $el = document.getElementById(`postArtworkImage-${props.variantId}`);
      const $cell = $el?.closest(".js-uploaded-artwork");
      if ($cell) {
        $cell.remove();
      }
    };

    watch(buildFailed, (failed) => {
      if (failed) {
        removeParentCell();
      }
    });

    onMounted(() => {
      loadFrameSpec();
      window.addEventListener("uploadItem", handleUploadEvent);
    });

    onUnmounted(() => {
      window.removeEventListener("uploadItem", handleUploadEvent);
    });

    return {
      frameSpec,
      buildFailed,
      galleryZoomCell,
      showMaskRenderer,
    };
  },
};
</script>
